import Footer from "../../../components/Footer/Footer";
import InstitucionalContainer from "../../../components/InstitucionalContainer/InstitucionalContainer";
import NavBar from "../../../components/NavBar/NavBar";

const QuemSomos = () => {
    return (
        <>
            <NavBar />
            <InstitucionalContainer/>
            <Footer/>
        </>
        
    )
}
export default QuemSomos;